import { REPORT_DATA,GET_REPORT_DATA,SET_360_VIEW_DATA
 } from "../actionTypes/ReportActionTypes";

const initialState = {
	reportData : null,
    existState : null,
    threeSixtyView: {} // Keyed by meta_table_id: { [meta_table_id]: { reportsList: [], scene: { children: [] }, layoutList: [] } }
}

 const ReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case REPORT_DATA:
            return {
                ...state,
                reportData: action.payload,
                existState: action.existState
            };  
        case GET_REPORT_DATA:
            return state.reportData;
        case SET_360_VIEW_DATA:
            const { meta_table_id, reportsList, sceneChildren, layoutList } = action.payload;
            return {
                ...state,
                threeSixtyView: {
                    ...state.threeSixtyView,
                    [meta_table_id]: {
                        reportsList: reportsList,
                        scene: {
                            children: sceneChildren
                        },
                        layoutList: layoutList
                    }
                }
            };
        default:
            return state;
    }
    
}
export default  ReportReducer;